export default class CountRule {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/segment/count-rule.html'),
            scope: {
                rule: '=',
                rulesList: '=',
                groups: '=',
                operatorGroups: '=',
                segmentRules: '='
            },
            controller: CountRuleController,
            controllerAs: 'ctrl'
        }
    }
};

class CountRuleController {
    constructor($scope, $element, $filter) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.groups = $scope.groups;
        this.operatorGroups = $scope.operatorGroups;
        $element.find('#js-count-rule-field-select').on('click', '.dropdown-header', this.onGroupSelect.bind(this));
    }

    onGroupSelect($event) {
        const uiSelectScope = angular.element($event.currentTarget).scope();
        let groupId = null;
        if (uiSelectScope.$group && uiSelectScope.$group.items && uiSelectScope.$group.items && uiSelectScope.$group.items.length) {
            groupId = uiSelectScope.$group.items[0].groupId;
        }
        if (groupId) {
            this.$scope.rule.group = groupId;
            this.$scope.rule.primary = null;
            uiSelectScope.$select.select(undefined);
            uiSelectScope.$select.close();
        }
    }

    onCustomFieldSelect($item) {
        if ($item) {
            this.$scope.rule.group = $item.groupId;
        }
    }

    removeRule() {
        if (this.$scope.segmentRules.aggregateConstraints && this.$scope.segmentRules.aggregateConstraints.count) {
            this.$scope.segmentRules.aggregateConstraints.count.rules = [];
        }

        this.$scope.rulesList.splice(this.$scope.rulesList.indexOf(this.$scope.rule), 1);
    }

    getPlaceholder() {
        let groupName;
        if (this.$scope.rule.group) {
            groupName = this.groups.find(customFiled => customFiled.groupId === this.$scope.rule.group).groupName;
        }
        return groupName || this.$filter('translate')('SEGMENTATION:SHOW:COUNT_RULE_LABEL');
    }

}

CountRuleController.$inject = ['$scope', '$element', '$filter'];
